import { Module, VuexModule, Mutation, getModule } from "vuex-module-decorators";
import { ISettings, store } from "@/loader";

@Module({
	name: "settings",
	store,
	dynamic: true,
	namespaced: true,
})
export class SettingsModule extends VuexModule implements ISettings {
	/** Application ID */
	public algolia_aplication_id: string = "";
	/** Search API Key */
	public algolia_search_api_key: string = "";
	/** Categories Index */
	public algolia_categories_index: string = "";
	/** Products Index */
	public algolia_products_index: string = "";

	@Mutation
	public init() {
		if (window.laboandco_data?.settings) {
			this.algolia_aplication_id = String.orDefault(window.laboandco_data.settings.algolia_aplication_id);
			this.algolia_search_api_key = String.orDefault(window.laboandco_data.settings.algolia_search_api_key);
			this.algolia_categories_index = String.orDefault(window.laboandco_data.settings.algolia_categories_index);
			this.algolia_products_index = String.orDefault(window.laboandco_data.settings.algolia_products_index);
		}
	}
}

export const settings = getModule(SettingsModule, store);
